/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Wpm_LabelInputs */

const en_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute`)
};

const fr_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mots par minute`)
};

const de_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wörter pro Minute`)
};

const it_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parole al minuto`)
};

const ru_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слова в минуту`)
};

const es_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabras por minuto`)
};

const zh_cn2_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟字数`)
};

const ja_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分あたりの単語数`)
};

const hi_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द प्रति मिनट`)
};

const pt_pt2_style_guide_manager_wpm_label = /** @type {(inputs: Style_Guide_Manager_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras por minuto`)
};

/**
* | output |
* | --- |
* | "Words Per Minute" |
*
* @param {Style_Guide_Manager_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_wpm_label = /** @type {((inputs?: Style_Guide_Manager_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_wpm_label(inputs)
	if (locale === "de") return de_style_guide_manager_wpm_label(inputs)
	if (locale === "it") return it_style_guide_manager_wpm_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_wpm_label(inputs)
	if (locale === "es") return es_style_guide_manager_wpm_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_wpm_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_wpm_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_wpm_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_wpm_label(inputs)
	return en_style_guide_manager_wpm_label(inputs)
});